import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";

import DeliveryNewPost from "./delivery/DeliveryNewPost/DeliveryNewPost";
import DeliveryUkrpost from "./delivery/DeliveryUkrpost/DeliveryUkrpost";

import NewPost from "../../../assets/img/new_post.png";
import Delivery from "../../../assets/img/delGroup.svg";
import Pickup from "../../../assets/img/pickup.svg"

import DeliveryPickup from "./delivery/DeliveryPickup/DeliveryPickup";
import ShippingAddress from "../../../interfaces/ShippingAddress";
import {CarrierType} from "../../../enums/CarrierType";


import PaymentAndPickupData from "../../../interfaces/PaymentAndPickupData";
import DeliveryDelivery from "./delivery/DeliveryDelivery/DeliveryDelivery";

import "./OrderProductsDelivery.sass"
import DeliveryDpd from "./delivery/DeliveryDpd/DeliveryDpd";
import DeliveryRaben from "./delivery/DeliveryRaben/DeliveryRaben";
import DeliveryByAddress from "./delivery/DeliveryByAddress/DeliveryByAddress";
import PaymentType from "../../../interfaces/PaymentType";
import PaymentsList from "../../../interfaces/PaymentType";


const OrderProductsDelivery: React.FC<{
    onChange: Function,
    shippingData?: ShippingAddress | null,
    onPaymentPickupDataChange?: (data: PaymentAndPickupData) => void,
    paymentPickupData?: PaymentAndPickupData,
    showPayOnDelivery: boolean,
    weight: number,
    paymentTypesList?: PaymentsList,
    handleWarehouse?: (id: number) => void, }> = (
    {onChange,
        shippingData,
        onPaymentPickupDataChange,
        paymentPickupData,
        showPayOnDelivery,
        weight,
        paymentTypesList,
        handleWarehouse
    }) => {
    const {t} = useTranslation();

    const [tabIndex, setTabIndex] = useState(0);

    return (
        <div>
                <Tabs className="delivery-tab-services" selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                    <TabList>
                        {process.env.REACT_APP_LOCATION !== 'pl' ?  <>
                        {shippingData == null || shippingData?.carrierType == CarrierType.NewPost ? <Tab>
                            <div className="logo-delivery new-post_tab">
                                <img src={NewPost} alt="NewPost"/>
                            </div>
                        </Tab> : null}

                        {shippingData == null || shippingData?.carrierType == CarrierType.Delivery ? <Tab>
                            <div className="logo-delivery delivery_tab">
                                <img src={Delivery} alt="Delivery"/>
                            </div>
                        </Tab> : null}
                        {shippingData == null || shippingData?.carrierType == CarrierType.AddressDelivery ? <Tab>
                            <div className="logo-delivery ukr-post_tab">
                                <span className="img"><img src={Pickup} alt="Pickup"/></span>
                                <span className="value">{t('carrierType.UkrPost')}</span>
                            </div>
                        </Tab> : null}

                            </> : <>
                            {shippingData == null || shippingData?.carrierType == CarrierType.DPD ? <Tab>
                                <div className="logo-delivery dpd-post_tab">
                                    <span className="value">DPD</span>
                                </div>
                            </Tab> : null}

                            {shippingData == null || shippingData?.carrierType == CarrierType.Raben ? <Tab>
                                <div className="logo-delivery raben-post_tab">
                                    <span className="value">Raben</span>
                                </div>
                            </Tab> : null}

                            {shippingData == null || shippingData?.carrierType == CarrierType.AddressDelivery ? <Tab>
                                <div className="logo-delivery ukr-post_tab">
                                    <span className="img"><img src={Pickup} alt="Pickup"/></span>
                                    <span className="value">{t('carrierType.UkrPost')}</span>
                                </div>
                            </Tab> : null}
                        </>}

                        {onPaymentPickupDataChange ? <Tab>
                            <div className="logo-delivery pickup_tab">
                                <span className="img"><img src={Pickup} alt="Pickup"/></span>
                                <span className="value">{t('delivery.pickupDelivery')}</span>
                            </div>
                        </Tab>  : null}
                    </TabList>

                    {process.env.REACT_APP_LOCATION !== 'pl' ?  <>
                    {shippingData == null || shippingData?.carrierType == CarrierType.NewPost ? <TabPanel>
                        <DeliveryNewPost
                            onChange={onChange}
                            shippingAddress={shippingData}
                            onPaymentAndPickupDataChange={onPaymentPickupDataChange}
                            showPayOnDelivery={showPayOnDelivery}
                            weight={weight}
                        />
                    </TabPanel> : null }
                    {shippingData == null || shippingData?.carrierType == CarrierType.Delivery ? <TabPanel>
                        <DeliveryDelivery
                            onChange={onChange}
                            shippingAddress={shippingData}
                            onPaymentAndPickupDataChange={onPaymentPickupDataChange}
                            showPayOnDelivery={showPayOnDelivery}
                        />
                    </TabPanel> : null}
                        {shippingData == null || shippingData?.carrierType == CarrierType.AddressDelivery ? <TabPanel>
                        <DeliveryUkrpost
                            onChange={onChange}
                            shippingAddress={shippingData}
                            onPaymentAndPickupDataChange={onPaymentPickupDataChange}
                            showPayOnDelivery={false}
                        />
                    </TabPanel> : null}
                            {onPaymentPickupDataChange ? <TabPanel>
                        <DeliveryPickup
                            onChange={onPaymentPickupDataChange}
                            paymentAndPickupData={paymentPickupData}
                            handleWarehouse={handleWarehouse}
                        />
                    </TabPanel> : null}
                    </> : <>
                        {shippingData == null || shippingData?.carrierType == CarrierType.DPD ? <TabPanel>
                            <DeliveryDpd
                                onChange={onChange}
                                shippingAddress={shippingData}
                                onPaymentAndPickupDataChange={onPaymentPickupDataChange}
                                showPayOnDelivery={showPayOnDelivery}
                                paymentTypesList={paymentTypesList && paymentTypesList[CarrierType.DPD]}
                            />
                        </TabPanel> : null }
                        {shippingData == null || shippingData?.carrierType == CarrierType.Raben ? <TabPanel>
                            <DeliveryRaben
                                onChange={onChange}
                                shippingAddress={shippingData}
                                onPaymentAndPickupDataChange={onPaymentPickupDataChange}
                                showPayOnDelivery={showPayOnDelivery}
                                paymentTypesList={paymentTypesList && paymentTypesList[CarrierType.Raben]}
                            />
                        </TabPanel> : null }
                        {shippingData == null || shippingData?.carrierType == CarrierType.AddressDelivery ? <TabPanel>
                            <DeliveryByAddress
                                onChange={onChange}
                                shippingAddress={shippingData}
                                onPaymentAndPickupDataChange={onPaymentPickupDataChange}
                                showPayOnDelivery={false}
                            />
                        </TabPanel> : null}
                    </>}

                    {onPaymentPickupDataChange ? <TabPanel>
                        <DeliveryPickup onChange={onPaymentPickupDataChange} paymentAndPickupData={paymentPickupData} handleWarehouse={handleWarehouse} />
                    </TabPanel> : null}
                </Tabs>

        </div>
    )
}
export default OrderProductsDelivery